
      const appName = import.meta.env.VITE_APP_TITLE || 'DCA ERP';
      const titleElement = document.getElementById('app-title');
      const metaTitleElement = document.getElementById('meta-title');
      const metaAuthorElement = document.getElementById('meta-author');
      const ogTitleElement = document.getElementById('meta-og-title');
      const twitterTitleElement = document.getElementById('meta-twitter-title');
      
      if (titleElement) {
        titleElement.textContent = `${appName} | Gestion de votre entreprise`;
      }
      if (metaTitleElement) {
        metaTitleElement.setAttribute('content', `${appName} | Gestion de votre entreprise`);
      }
      if (metaAuthorElement) {
        metaAuthorElement.setAttribute('content', appName);
      }
      if (ogTitleElement) {
        ogTitleElement.setAttribute('content', `${appName} | Gestion de votre entreprise`);
      }
      if (twitterTitleElement) {
        twitterTitleElement.setAttribute('content', `${appName} | Gestion de votre entreprise`);
      }
    